module.exports = __webpack_public_path__ + "static/media/vueLogoTransparent.069f080b.png";